import { schema } from "normalizr";
import { teamRolesTypes } from "../types";
import Resource from "./resource";
import {client} from "../store";

const rolesSchema = new schema.Entity("teamRoles");

export default new Resource("/team-roles", teamRolesTypes, rolesSchema);

client.enableAutoCamelCase('/team-roles');